import styled from 'styled-components';
import { Text } from '@components/typography';

import Typist from 'react-typist';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { Column, Columns } from '@components/Columns';
import { Box } from '@components/Box';
import { defaultBase64Placeholder } from '@components/CloudImage';

export const StyledTypist = styled(Typist)`
  span.Cursor.Cursor--blinking {
    font-size: 96px;
    color: ${themeColor('blue6')};
    ${themeMediaQuery('below_sm')} {
      font-size: 40px;
    }
  }

  .typistText {
    font-size: 96px;
    font-family: 'AkkuratLLSub-LightSubset';
    line-height: 54px;
    letter-spacing: -0.04em;
    color: ${themeColor('blue6')};
    ${themeMediaQuery('below_sm')} {
      font-size: 40px;
    }
  }
`;

export const StyledTypistTextBox = styled(Box)`
  width: 100%;
  height: 155px;
  padding-left: 36px;
  border-radius: 16px;
  border: solid 4px ${themeColor('blue2')};
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(3)};
    padding-left: 16px;
    height: max-content;
    min-height: 70px;
    width: 345px;
  }
`;

export const StyledTypistImageBackground = styled(Box)<{ isScrolledIntoView: boolean }>`
  position: absolute;
  right: 60px;
  top: -60px;
  height: 960px;
  width: 960px;
  border-radius: 50%;
  overflow: hidden;
  &:before {
    content: '';
    background: url('${({ isScrolledIntoView }) =>
      isScrolledIntoView ? cloudAssetUrl('wedding-invitations/rsvp-by-name/rsvp-by-name-star.jpg') : defaultBase64Placeholder}');
    background-size: cover;
    display: block;
    width: 100%;
    height: 100%;
    border: solid 20px ${themeColor('blue4')};
    border-radius: 50%;
  }
  ${themeMediaQuery('lg')} {
    right: 120px;
  }
  ${themeMediaQuery('below_sm')} {
    position: relative;
    width: 478px;
    height: 478px;
    right: 42%;
    overflow: unset;
  }
`;

export const StyledRsvpText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const StyledTypistFieldWrapper = styled.div`
  position: absolute;
  left: 160px;
  top: 50%;
  width: 1024px;
  height: 334px;
  border-radius: 167px;
  background: white;
  padding: 55px 102px 70px 102px;
  ${themeMediaQuery('below_sm')} {
    top: 66%;
    width: 480px;
    padding: 23px 43px 23px 54px;
    height: 146px;
    left: 59%;
    top: 48%;
  }
`;

export const StyledSection = styled(Box)`
  position: relative;
  height: 840px;
  ${themeMediaQuery('below_sm')} {
    height: 1000px;
  }
`;

export const StyledColumns = styled(Columns)`
  height: 100%;
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

export const LeftColumn = styled(Column)`
  position: relative;
  height: 100%;
  ${themeMediaQuery('below_sm')} {
    height: 63%;
  }
`;
